import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { AudienceSegmentationContextProviderQuery } from './AudienceSegmentationContextProviderQuery.graphql';

export function preloadAudienceSegmentationContext({ accountId }: { accountId: string }) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: AudienceSegmentationContextProviderQuery,
		variables: {
			accountId,
		},
	});
}
